import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import { AnalyticsConsent, ClarityService, PRIVACY_POLICY_URL } from '../../shared/services/clarity.service';

/**
 * "Prywatność" page, reachable from the "Moje konto" menu for every role: lets the signed-in user change the
 * decision on analytics cookies (Microsoft Clarity) given on the consent bar.
 */
@Component({
  selector: 'app-privacy-settings',
  standalone: true,
  imports: [FormsModule, InputSwitchModule],
  templateUrl: './privacy-settings.component.html',
  styleUrl: './privacy-settings.component.scss',
})
export class PrivacySettingsComponent {
  private readonly clarity = inject(ClarityService);

  readonly enabled = this.clarity.enabled;
  readonly privacyPolicyUrl = PRIVACY_POLICY_URL;

  get consent(): AnalyticsConsent | null {
    return this.clarity.consent;
  }

  get statusLabel(): string {
    switch (this.consent) {
      case 'granted':
        return 'Zgoda udzielona';
      case 'denied':
        return 'Zgoda odrzucona';
      default:
        return 'Nie podjęto jeszcze decyzji';
    }
  }

  toggle(granted: boolean): void {
    this.clarity.setConsent(granted ? 'granted' : 'denied');
  }
}
